import {Component, inject, input} from '@angular/core';
import {
	IonBackButton,
	IonButtons,
	IonHeader,
	IonIcon,
	IonButton,
	IonTitle,
	IonToolbar
} from '@ionic/angular/standalone';
import {TranslocoDirective} from '@jsverse/transloco';
import {addIcons} from 'ionicons';
import {
	atOutline,
	bagRemoveOutline,
	bookOutline,
	checkboxOutline,
	colorWandOutline,
	documentText,
	documentTextOutline,
	flameOutline,
	globeOutline,
	helpBuoyOutline,
	keyOutline,
	libraryOutline,
	megaphoneOutline,
	personOutline,
	searchOutline,
	chatbubbleEllipsesOutline,
	chatbubblesOutline,
	homeOutline,
	mailOutline,
	peopleOutline,
	chevronForwardOutline
} from 'ionicons/icons';
import {RouterLink} from '@angular/router';
import {TranslateHelperService} from '@services';
import {LanguageButtonComponent} from '../language-button/language-button.component';

@Component({
	           selector: 'app-public-header',
	           standalone: true,
	           imports: [
			TranslocoDirective,
		           IonBackButton,
		           IonButtons,
		           IonHeader,
		           IonToolbar,
		           IonTitle,
		           IonIcon,
		           IonButton,
		           RouterLink,
		           LanguageButtonComponent
	           ],
	           templateUrl: './public-header.component.html',
	           styleUrl: './public-header.component.scss'
           })
export class PublicHeaderComponent {
	title = input.required<string>();
	icon = input.required<string>();
	translateTitle = input<boolean>(true);
	backHref = input<string | null>(null);
	public readonly translateService: TranslateHelperService = inject(TranslateHelperService);

	constructor() {
		addIcons({
			globeOutline,
			personOutline,
			keyOutline,
			atOutline,
			bagRemoveOutline,
			bookOutline,
			checkboxOutline,
			flameOutline,
			documentText,
			documentTextOutline,
			colorWandOutline,
			libraryOutline,
			mailOutline,
			peopleOutline,
			helpBuoyOutline,
			megaphoneOutline,
			searchOutline,
			chatbubbleEllipsesOutline,
			chatbubblesOutline,
			homeOutline,
			chevronForwardOutline
		});
	}
}
